import { axios } from '@/lib/axios';

import { AuthUser } from '@/features/auth';

export type RegisterCredentialsDTO = {
  email: string;
  password: string;
  firstName: string;
  title: string;
  lastName: string;
};

export const registerWithEmailAndPassword = (
  data: RegisterCredentialsDTO
): Promise<AuthUser> => {
  return axios.post('/auth/register', data);
};
